import AxiosConfig from '@/config/axios-config'

export const ResumoAPI = {

  listar (pagina, filtro) {
    return AxiosConfig.jalekoAPI().get('/admin/resumos',
      {
        params: {
          page: pagina,
          licao_id: filtro && filtro.licao_id
        }
      }).then(response => response.data.resumos)
  },

  salvar (resumos, nomes, resumosExistentes, licaoId) {
    let formData = new FormData()
    resumos.map(arquivo => {
      formData.append('resumos[]', arquivo)
    })
    nomes.map(nome => {
      formData.append('nomes[]', nome)
    })
    resumosExistentes.map(resumo => {
      formData.append('resumosExistentes[]', resumo.id)
    })
    formData.append('licaoId', licaoId)
    return AxiosConfig.secureJalekoAPI().post(`/admin/pdfs/resumos`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    }).then(response => response.data)
  },

  deletar (id) {
    return AxiosConfig.secureJalekoAPI().delete(`/admin/resumo/${id}`).then(response => response.data)
  }

}

export default ResumoAPI
